
import './BasicLogin.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiArrowRight, FiLock } from 'react-icons/fi';
import axios from "axios";
import fnc from '../mymod/commFunction';
import { useSelector, useDispatch } from 'react-redux';
import { setIsLoggedIn, setUserInfo, setUserInfo2, setAcaName, setChoJoongGo, setIsPaid } from '../reduxToolkit/redux';
import { doc, setDoc, arrayUnion, serverTimestamp } from 'firebase/firestore';
import { firestore } from '../page_firebase/firebaseConfig';
import { clearBillingSession, saveBillingSession } from '../billing/billingClient';

const PARENT_SESSION_STORAGE_KEY = 'guardianLoginSession';
const PARENT_SESSION_LIST_STORAGE_KEY = 'guardianLoginSessions';
const PARENT_DEVICE_KEY_STORAGE_KEY = 'guardianDeviceKey';
const LOGIN_CERT_CODE = 'FD2001';

function BasicLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const signupCertCode = typeof location.state?.signupCertCode === 'string' && location.state.signupCertCode.trim() === LOGIN_CERT_CODE ? LOGIN_CERT_CODE : '';
  const signupLoginId = signupCertCode && typeof location.state?.signupLoginId === 'string' ? location.state.signupLoginId : '';
  const dispatch = useDispatch();
  const certCode = LOGIN_CERT_CODE;
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [loginMode, setLoginMode] = useState('member');
  const [parentPhone, setParentPhone] = useState('');
  const [parentCertCode, setParentCertCode] = useState('');
  const [parentCodeSent, setParentCodeSent] = useState(false);
  const [sendingParentCode, setSendingParentCode] = useState(false);
  const [verifyingParentLogin, setVerifyingParentLogin] = useState(false);
  const [parentSavedSessionAvailable, setParentSavedSessionAvailable] = useState(false);
  const userIdRef = useRef(null);  // useRef 훅을 사용해 참조 생성
  const parentAutoLoginTriedRef = useRef(false);
  const version = useSelector(state => state.reduxStore.version);
  
  const [isAutoLoginChecked, setAutoLoginChecked] = useState(false);
  const [isIdChecked, setIdChecked] = useState(false);

  const [appVersion, setAppVersion] = useState(''); // 앱 버전 상태
  const currentVersion = localStorage.getItem('updateVersion');


  const deviceInfo = localStorage.getItem('DeviceInfo');//html과 index.js에 있음
  const fcmToken = localStorage.getItem('FcmToken');
  const deviceKind = localStorage.getItem('DeviceKind');

  let acaDbName;
  const normalizePhone = (value) => String(value || '').replace(/[^0-9]/g, '');

  const getParentTalkId = (parentUser, phoneValue, academyCodeValue) => {
    const parentLoginId = String(parentUser?.id2 || '').trim();
    const phone = normalizePhone(parentUser?.phone || phoneValue);
    const academyCode = String(parentUser?.acaCode || academyCodeValue || '').trim();
    const idWithoutAcademyCode = parentLoginId
      || (phone ? `P_${phone}` : String(parentUser?.id || '').replace(/^.+_(P_[0-9]{10,11})$/, '$1'));

    return academyCode && idWithoutAcademyCode
      ? `${academyCode}_${idWithoutAcademyCode}`
      : idWithoutAcademyCode;
  };
  

  useEffect(() => {
    // 컴포넌트가 마운트될 때 input 요소에 포커스를 자동으로 맞춤
    restoreCookie();
    // userIdRef.current.focus(); 이거 하지마 팝업 떠서 귀찮아
    setAppVersion(version);//초기값 공백으로 해야하고, [version] 붙여야함 안드로이드에서 못 읽어와

  }, [version]);

  useEffect(() => {
    if (loginMode !== 'parent') {
      setParentSavedSessionAvailable(false);
      return;
    }

    const phone = normalizePhone(parentPhone);
    if (!certCode || !/^01[0-9]{8,9}$/.test(phone)) {
      setParentSavedSessionAvailable(false);
      return;
    }

    setParentSavedSessionAvailable(Boolean(getMatchingParentSession(certCode, phone)));
  }, [loginMode, certCode, parentPhone]);

  const handleSubmit = (event) => {
    event.preventDefault(); // 폼 전송에 의한 페이지 새로고침 방지

    if (loginMode === 'parent') {
      fncParentLogin();
      return false;
    }
 
    if(!certCode){
      alert('인증코드를 입력하세요!');
      return false;
    }

    if(!userId){
      alert('아이디를 입력하세요!');
      return false;
    }
    if(!password){
      alert('패쓰워드를 입력하세요!');
      return false;
    }

    fncInfoAca();
  };

  function fncInfoAca(afterReady) {
    const targetCertCode = LOGIN_CERT_CODE;
    fnc.sendAxios('/infoAca', { certCode: targetCertCode }, (res) => {
      if (res && Array.isArray(res) && res[0] && res[0].acaDbName) {  
        let acaCode = res[0].acaCode;
        acaDbName = res[0].acaDbName;
        const acaName = res[0].acaName;
        const s3_acaCode = res[0].s3_acaCode;
        const choJoongGo = res[0].choJoongGo;
        const isPaidValue = res[0].isPaid;
        
        fnc.setCookie('acaCode', acaCode, 1000);
        fnc.setCookie('acaDbName', acaDbName, 1000);
        fnc.setCookie('acaName', acaName, 1000);
        fnc.setCookie('s3_acaCode', s3_acaCode, 1000);
        // fnc.setCookie('choJoongGo', choJoongGo, 1000);   
        dispatch(setIsPaid(isPaidValue));
        dispatch(setAcaName(acaName));
        dispatch(setChoJoongGo(choJoongGo));
        updateDbName(acaDbName);//인증코드 변경시 두 번 클릭해야 dbName이 변경됨??(미해결)
        if (typeof afterReady === 'function') {
          afterReady({ certCode: targetCertCode, acaCode, acaDbName, acaName, s3_acaCode, choJoongGo, isPaidValue });
          return;
        }
        fncBasicLogin(userId, password);//로그인 실행

      } else {
        alert('인증코드 정보가 올바르지 않습니다.');
        if (typeof afterReady === 'function') afterReady(null);
      }
    });
  }


  function updateDbName(acaDbName) {
    // 기존 인터셉터 제거
    axios.interceptors.request.handlers = [];//이거 없어서 고생
    // 새 인터셉터 등록
    axios.interceptors.request.use(config => {
      if (config.method === 'post' && config.data) {
        config.data.db = acaDbName;
      }
      return config;
    }, error => {
      console.error('Axios 요청 인터셉터에서 오류 발생:', error);
      return Promise.reject(error);
    });
  }


  // function fncBasicLogin(id, pw) {
    
  //   fnc.sendAxios('/kuesbLogin', { id, pw }, (res) => {

  //     if (res.length) {

  //       dispatch(setUserInfo(res[0]));
  //       dispatch(setIsLoggedIn(true));

  //       fnc.setCookie('certCode', certCode);
  //       fnc.setCookie('id', res[0].id);
  //       fnc.setCookie('pw', pw);
  //       fnc.setCookie('stCode', res[0].stCode);
  //       fnc.setCookie('userName', res[0].name);
  //       fnc.setCookie('email', res[0].email);
  //       fnc.setCookie('lastLoginTime', Date.now(), 1);

  //       // fnc.setCookie('acaCode', 2000);

  //       const stCode = res[0].stCode;

  //       if (deviceKind) {//ios 또는 android일 때만        
  //         fncSavePushToken(id, stCode, fcmToken ?? '', deviceInfo ?? '', deviceKind ?? '');
  //       }

  //       navigate('/'); 

  //       // if(res.token) {
  //       //   if(basicid === 'admin') {
  //       //     fnc.setCookie('token', res.token, 1);
  //       //     // alert( fnc.getCookie('token'))
  //       //     dispatch(setIsAdmin(true));
  //       //     dispatch(setIsLoggedIn(true));
  //       //     navigate('/home'); 
  //       //   }else{
  //       //     // fnc.setCookie_pure('token','',1);
  //       //   }     
  //       // }

  //     } else {
  //       alert('정보가 올바르지 않습니다.')
  //       console.log(res,"속성이 obj 내에 없습니다.");
  //     }
  //   });
  // }

  

  function fncBasicLogin(id, pw) {
    clearBillingSession();
    fnc.sendAxios('/kuesbLogin', { id, pw, certCode }, (res) => {

      if (res.length) {
        const { billingSession, ...loginUser } = res[0];
        saveBillingSession(billingSession);
        dispatch(setUserInfo(loginUser));
        dispatch(setIsLoggedIn(true));

        fnc.setCookie('certCode', certCode);
        fnc.setCookie('id', res[0].id);
        fnc.setCookie('pw', pw);
        fnc.setCookie('stCode', res[0].stCode);
        fnc.setCookie('userName', res[0].name);
        fnc.setCookie('email', res[0].email);
        fnc.setCookie('lastLoginTime', Date.now(), 1);

        // fnc.setCookie('acaCode', 2000);

        const stCode = res[0].stCode;
        if (deviceKind) {//ios 또는 android일 때만        
          fncSavePushToken(id, stCode, fcmToken ?? '', deviceInfo ?? '', deviceKind ?? '');
        }

        const acaCode = certCode;
        const talkId = acaCode + '_' + res[0].id;
        const nickname = res[0].name || '';
        const profile_image = '';
        const id2 = res[0].id;//basic login은 id2 없음

        fncInsertSocialLogin(acaCode, talkId, id2, nickname, profile_image) 
        // navigate('/'); 
    
      } else {
        alert('정보가 올바르지 않습니다.')
        console.log(res,"속성이 obj 내에 없습니다.");
      }
    }, (error) => {
      alert(error?.response?.data?.error || '로그인 정보를 확인하지 못했습니다.');
    });
  }

  function getParentDeviceKey() {
    const savedDeviceKey = localStorage.getItem(PARENT_DEVICE_KEY_STORAGE_KEY);
    if (savedDeviceKey) return savedDeviceKey;

    let parsedDeviceInfo = null;
    try {
      parsedDeviceInfo = deviceInfo ? JSON.parse(deviceInfo) : null;
    } catch (error) {
      parsedDeviceInfo = null;
    }

    const deviceKey = parsedDeviceInfo?.vendorID
      || parsedDeviceInfo?.deviceId
      || parsedDeviceInfo?.uuid
      || (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}_${Math.random().toString(16).slice(2)}`);

    localStorage.setItem(PARENT_DEVICE_KEY_STORAGE_KEY, deviceKey);
    return deviceKey;
  }

  function getParentSessionKey(certCodeValue, phoneValue) {
    const loginCertCode = String(certCodeValue || '').trim();
    const phone = normalizePhone(phoneValue);
    if (!loginCertCode || !phone) return '';
    return `${loginCertCode}_${phone}`;
  }

  function isValidParentSession(session) {
    if (!session?.token || !session?.guardianId || !(session?.certCode || session?.acaCode)) {
      return false;
    }

    return true;
  }

  function isFixedAcademyParentSession(session) {
    // acaCode is the server's internal academy ID, not a login certificate code.
    return isValidParentSession(session) && String(session.certCode || '').trim() === LOGIN_CERT_CODE;
  }

  function getStoredParentSessionMap() {
    try {
      const rawSessions = localStorage.getItem(PARENT_SESSION_LIST_STORAGE_KEY);
      if (!rawSessions) return {};

      const sessions = JSON.parse(rawSessions);
      if (!sessions || typeof sessions !== 'object' || Array.isArray(sessions)) {
        localStorage.removeItem(PARENT_SESSION_LIST_STORAGE_KEY);
        return {};
      }

      return sessions;
    } catch (error) {
      localStorage.removeItem(PARENT_SESSION_LIST_STORAGE_KEY);
      return {};
    }
  }

  function saveStoredParentSessionMap(sessions) {
    localStorage.setItem(PARENT_SESSION_LIST_STORAGE_KEY, JSON.stringify(sessions));
  }

  function getStoredParentSession() {
    try {
      const rawSession = localStorage.getItem(PARENT_SESSION_STORAGE_KEY);
      if (!rawSession) return null;

      const session = JSON.parse(rawSession);
      if (!isValidParentSession(session)) {
        localStorage.removeItem(PARENT_SESSION_STORAGE_KEY);
        return null;
      }

      return isFixedAcademyParentSession(session) ? session : null;
    } catch (error) {
      localStorage.removeItem(PARENT_SESSION_STORAGE_KEY);
      return null;
    }
  }

  function getStoredParentSessionByPhone(certCodeValue, phoneValue) {
    if (String(certCodeValue || '').trim() !== LOGIN_CERT_CODE) return null;
    const sessionKey = getParentSessionKey(certCodeValue, phoneValue);
    if (!sessionKey) return null;

    const sessions = getStoredParentSessionMap();
    const session = sessions[sessionKey];
    if (isFixedAcademyParentSession(session)
      && getParentSessionKey(session.certCode, session.phone || session.guardianPhone) === sessionKey) return session;

    if (session) {
      delete sessions[sessionKey];
      saveStoredParentSessionMap(sessions);
    }

    const lastSession = getStoredParentSession();
    const lastSessionKey = getParentSessionKey(lastSession?.certCode || lastSession?.acaCode, lastSession?.phone || lastSession?.guardianPhone);
    return lastSessionKey === sessionKey ? lastSession : null;
  }

  function getMatchingParentSession(certCodeValue, phoneValue) {
    const inputPhone = normalizePhone(phoneValue);
    const savedSession = getStoredParentSessionByPhone(certCodeValue, inputPhone);
    const savedPhone = normalizePhone(savedSession?.phone || savedSession?.guardianPhone);

    return savedSession && savedPhone === inputPhone ? savedSession : null;
  }

  function saveParentSession(session, parentUser, acaInfo, phone) {
    if (!session?.token) return;

    const sessionData = {
      token: session.token,
      guardianId: session.guardianId || parentUser?.id || '',
      acaCode: session.acaCode || parentUser?.acaCode || acaInfo?.acaCode || '',
      certCode: LOGIN_CERT_CODE,
      acaDbName: acaInfo?.acaDbName || '',
      phone: session.guardianPhone || parentUser?.phone || phone || '',
      expiresAt: session.expiresAt || '',
      savedAt: Date.now()
    };

    localStorage.setItem(PARENT_SESSION_STORAGE_KEY, JSON.stringify(sessionData));

    const sessionKey = getParentSessionKey(sessionData.certCode || sessionData.acaCode, sessionData.phone);
    if (sessionKey) {
      const sessions = getStoredParentSessionMap();
      sessions[sessionKey] = sessionData;
      saveStoredParentSessionMap(sessions);
    }
  }

  function clearParentSession(session) {
    const sessionKey = getParentSessionKey(session?.certCode || session?.acaCode, session?.phone || session?.guardianPhone);
    if (sessionKey) {
      const sessions = getStoredParentSessionMap();
      if (sessions[sessionKey]) {
        delete sessions[sessionKey];
        saveStoredParentSessionMap(sessions);
      }
    }

    setParentSavedSessionAvailable(false);
    localStorage.removeItem(PARENT_SESSION_STORAGE_KEY);
  }

  function fncParentAutoLogin(session) {
    if (!isFixedAcademyParentSession(session)) return;
    const loginCertCode = LOGIN_CERT_CODE;

    setLoginMode('parent');
    setParentPhone(session.phone || session.guardianPhone || '');
    setVerifyingParentLogin(true);

    fncInfoAca((acaInfo) => {
      if (!acaInfo) {
        clearParentSession(session);
        setVerifyingParentLogin(false);
        return;
      }

      fnc.sendAxios('/socialLoginRoutes/guardian/autoLogin', {
        acaCode: acaInfo.acaCode,
        certCode: loginCertCode,
        guardianId: session.guardianId,
        token: session.token,
        deviceKey: getParentDeviceKey(),
        deviceInfo: deviceInfo || '',
        db: acaInfo.acaDbName
      }, (res) => {
        if (!res || !res.success || !res.user) {
          clearParentSession(session);
          setParentSavedSessionAvailable(false);
          setVerifyingParentLogin(false);
          return;
        }

        fncCompleteParentLogin(res.user, acaInfo, res.user.phone || session.phone || '', res.session || session);
      });
    });
  }

  function fncCompleteParentLogin(parentUser, acaInfo, fallbackPhone, session) {
    const children = parentUser.children || [];
    const firstChild = children[0] || {};
    const parentName = parentUser.name || parentUser.nickname || '학부모';
    const parentStCode = firstChild.studentStCode || 0;
    const phone = parentUser.phone || fallbackPhone || '';
    const parentTalkId = getParentTalkId(parentUser, phone, acaInfo?.acaCode);
    const loginCertCode = LOGIN_CERT_CODE;

    const userInfo = {
      stCode: parentStCode,
      id: parentTalkId,
      id2: parentUser.id2 || '',
      name: parentName,
      email: '',
      hp: phone,
      nickname: parentName,
      photoURL: '',
      kind: 'parent',
      role: 'parent',
      children
    };

    const userInfo2 = {
      acaCode: parentUser.acaCode || acaInfo.acaCode,
      stCode: parentStCode,
      id: parentTalkId,
      id2: parentUser.id2 || '',
      name: parentName,
      email: '',
      hp: phone,
      nickname: parentName,
      photoURL: '',
      uid: '',
      role: 'parent',
      children
    };

    clearBillingSession();
    dispatch(setUserInfo(userInfo));
    dispatch(setUserInfo2(userInfo2));
    dispatch(setIsLoggedIn(true));

    fnc.setCookie('certCode', loginCertCode);
    fnc.setCookie('id', parentTalkId);
    fnc.setCookie('stCode', parentStCode);
    fnc.setCookie('userName', parentName);
    fnc.setCookie('hp', phone);
    fnc.setCookie('userRole', 'parent');
    fnc.setCookie('lastLoginTime', Date.now(), 1);
    fnc.setCookie('isIdChecked', 'false', 1000);
    fnc.setCookie('isAutoLoginChecked', 'false', 1000);
    setIdChecked(false);
    setAutoLoginChecked(false);
    setUserId('');
    setPassword('');

    if (session?.token) {
      saveParentSession(session, parentUser, acaInfo, phone);
    }

    if (deviceKind) {
      fncSavePushToken(parentTalkId, parentStCode, fcmToken ?? '', deviceInfo ?? '', deviceKind ?? '');
    }

    fncSaveFirebaseUserForPush({
      id: parentTalkId,
      name: parentName,
      nickname: parentName,
      phone,
      role: 'parent',
      acaCode: parentUser.acaCode || acaInfo.acaCode,
      children
    }).catch((error) => {
      console.warn('학부모 Firestore 푸시 사용자 저장 실패:', error);
    }).finally(() => {
      setVerifyingParentLogin(false);
      navigate('/');
    });
  }
  function fncParentSendCode() {
    const phone = normalizePhone(parentPhone);

    if (!certCode) {
      alert('인증코드를 입력하세요!');
      return;
    }

    if (!/^01[0-9]{8,9}$/.test(phone)) {
      alert('학부모 휴대폰 번호를 정확히 입력하세요.');
      return;
    }

    const savedSession = getMatchingParentSession(certCode, phone);
    if (savedSession) {
      parentAutoLoginTriedRef.current = true;
      fncParentAutoLogin(savedSession);
      return;
    }

    setSendingParentCode(true);
    fncInfoAca((acaInfo) => {
      if (!acaInfo) {
        setSendingParentCode(false);
        return;
      }

      fnc.sendAxios('/socialLoginRoutes/guardian/sendLoginCode', {
        acaCode: acaInfo.acaCode,
        certCode,
        phone,
        db: acaInfo.acaDbName
      }, (res) => {
        setSendingParentCode(false);
        if (res && res.success) {
          setParentCodeSent(true);
          alert(res.message || '인증번호가 전송되었습니다.');
        } else {
          alert(res?.message || '인증번호 전송에 실패했습니다.');
        }
      });
    });
  }

  function fncParentLogin() {
    const phone = normalizePhone(parentPhone);
    const code = String(parentCertCode || '').trim();

    if (!certCode) {
      alert('인증코드를 입력하세요!');
      return;
    }

    if (!/^01[0-9]{8,9}$/.test(phone)) {
      alert('학부모 휴대폰 번호를 정확히 입력하세요.');
      return;
    }

    if (!code) {
      const savedSession = getMatchingParentSession(certCode, phone);
      if (savedSession) {
        parentAutoLoginTriedRef.current = true;
        fncParentAutoLogin(savedSession);
        return;
      }

      alert('인증번호를 입력하세요.');
      return;
    }

    setVerifyingParentLogin(true);
    fncInfoAca((acaInfo) => {
      if (!acaInfo) {
        setVerifyingParentLogin(false);
        return;
      }

      fnc.sendAxios('/socialLoginRoutes/guardian/verifyLoginCode', {
        acaCode: acaInfo.acaCode,
        certCode,
        phone,
        code,
        deviceKey: getParentDeviceKey(),
        deviceInfo: deviceInfo || '',
        db: acaInfo.acaDbName
      }, (res) => {
        if (!res || !res.success || !res.user) {
          setVerifyingParentLogin(false);
          alert(res?.message || '학부모 로그인에 실패했습니다.');
          return;
        }

        fncCompleteParentLogin(res.user, acaInfo, phone, res.session);

      });
    });
  }

  async function fncSaveFirebaseUserForPush(user) {
    if (!user?.id) return;

    const userDocRef = doc(firestore, 'users', user.id);
    const userData = {
      id: user.id,
      name: user.name || user.nickname || user.id,
      nickname: user.nickname || user.name || user.id,
      phoneNumber: user.phone || '',
      role: user.role || 'member',
      acaCode: user.acaCode || certCode || '',
      children: user.children || [],
      isOnline: true,
      lastSeen: serverTimestamp(),
      updatedAt: serverTimestamp()
    };

    if (fcmToken) {
      userData.fcmTokens = arrayUnion(fcmToken);
    }

    await setDoc(userDocRef, userData, { merge: true });
  }
  function fncInsertSocialLogin(acaCode, id, id2, nickname, profile_image) {
          fnc.sendAxios('/socialLoginRoutes/insert/socialLogin_basicLogin', { acaCode, id, id2, nickname, profile_image, isSocialLogin: 'N' }, (res) => {
            console.log(res, '==========>>> res');
            if (res.success) {
                  fncSelectSocialLogin(id);
              } else {
              alert('저장에 실패했습니다.');
              console.log(res);
              }
          });
      
  }


function fncSelectSocialLogin(id) {
        fnc.sendAxios('/socialLoginRoutes/select/socialLogin', { id }, (res) => {

          console.log(res, '############# res');
            if (res && res.length > 0) {
                dispatch(setUserInfo2({
                    acaCode: res[0].acaCode || '',
                    nickname: res[0].nickname || '',
                    email: res[0].email || '',
                    id: res[0].id || '',
                    id2: res[0].id2 || '',//naver id 등 social login id 닉네임 아이디 임
                    profile_image: res[0].profile_image || '',
                    uid: res[0].uid || '' // firebase uid
                }));

        // userInfo2:{
        //     acaCode:'',
        //     stCode:'',
        //     id:'',
        //     id2:'',//naver id 등 social login id 닉네임 아이디 임
        //     name:'',
        //     email:'',
        //     hp:'',
        //     nickname:'',
        //     photoURL:'',
        //     uid:'', // firebase uid
        // },

                // dispatch(setUserInfo2(res[0]));
                console.log(res, 'userinfo2 res');
                dispatch(setIsLoggedIn(true));
                navigate('/'); 
            } else {
                alert('정보가 올바르지 않습니다.')
                console.log(res,"속성이 obj 내에 없습니다.");
            }
        });
    }



function fncSavePushToken(id, stCode, fcmToken, deviceInfo) {
  fnc.sendAxios('/kuesbPushRoutes/save/push', { id, stCode, fcmToken, deviceInfo, deviceKind }, (res) => {
    if (res) {
      console.log(res, 'save Token');
    } else {
      console.log(res,"속성이 obj 내에 없습니다.");
    }
  });
}

const handleIdClick = () => {
  if (isIdChecked) {
      setAutoLoginChecked(false);
      fnc.setCookie('isAutoLoginChecked', 'false', 1000);
  }
  setIdChecked(prev => !prev);
  fnc.setCookie('isIdChecked', String(!isIdChecked), 1000);
}

const handleAutoLoginClick = () => {
if (!isAutoLoginChecked) {
    setIdChecked(true);
    fnc.setCookie('isIdChecked', 'true', 1000);
}
setAutoLoginChecked(prev => !prev);
fnc.setCookie('isAutoLoginChecked', String(!isAutoLoginChecked), 1000);
}


function restoreCookie() {//주의: ios는 쿠키 못읽어 localstorage에 저장함으로 변경
  if (signupCertCode) {
    setUserId(signupLoginId);
    setPassword('');
    setLoginMode('member');
    setIdChecked(false);
    setAutoLoginChecked(false);
    return;
  }
  const savedCertCode = String(fnc.getCookie('certCode') || '').trim();
  const id = fnc.getCookie('id');
  const pw = fnc.getCookie('pw');
  const hp = normalizePhone(fnc.getCookie('hp'));
  const userRole = fnc.getCookie('userRole');
  const isIdChecked = fnc.getCookie('isIdChecked') === 'true';
  const isAutoLoginChecked = fnc.getCookie('isAutoLoginChecked') === 'true';
  const isParentLoginCookie = userRole === 'parent' || /^(?:.+_)?P_[0-9]{10,11}$/.test(id || '');

  const isFixedAcademyCookie = savedCertCode === LOGIN_CERT_CODE;
  setIdChecked(isFixedAcademyCookie && isIdChecked);
  setAutoLoginChecked(isFixedAcademyCookie && isAutoLoginChecked);

  const parentSession = getStoredParentSession();
  if (parentSession && !parentAutoLoginTriedRef.current) {
    parentAutoLoginTriedRef.current = true;
    setLoginMode('parent');
    setParentPhone(parentSession.phone || parentSession.guardianPhone || '');
    fncParentAutoLogin(parentSession);
    return;
  }


  if (!isFixedAcademyCookie) {
    setUserId('');
    setPassword('');
    return;
  }

  if (isParentLoginCookie) {
    setLoginMode('parent');
    if (hp) setParentPhone(hp);
    setParentCodeSent(false);
    setParentCertCode('');
    setUserId('');
    setPassword('');
    setIdChecked(false);
    setAutoLoginChecked(false);
    return;
  }

  if (id && isIdChecked) {
    setUserId(id);
  }

  if (pw && isAutoLoginChecked) {
    setPassword(pw);
  }


}


function handleUpdate() {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callWebSite) {
    window.webkit.messageHandlers.callWebSite.postMessage("https://naver.com");
  } else {
    console.warn("iOS 웹뷰에서 실행되지 않음");
  }
}



  return (
    <main className="lms-login" aria-labelledby="lms-login-title">
      <div className="lms-login-shell">
        <section className="lms-login-card">
          <header className="lms-login-heading">
            <h1 id="lms-login-title">로그인</h1>
            <p>나의 수업과 학습을 이어가세요.</p>
          </header>

          <div className="lms-login-modes" role="group" aria-label="로그인 유형">
            <button type="button" aria-pressed={loginMode === 'member'} onClick={() => setLoginMode('member')}>학생·선생님</button>
            <button type="button" aria-pressed={loginMode === 'parent'} onClick={() => setLoginMode('parent')}>학부모</button>
          </div>

          {signupCertCode && <p className="lms-login-notice" role="status">회원가입이 완료되었습니다. 새 계정으로 로그인해 주세요.</p>}

          <form className="lms-login-form" onSubmit={handleSubmit}>
            <div className="lms-login-academy">
              <div>
                <label htmlFor="cerCode">학원코드</label>
                <input type="text" id="cerCode" value={certCode} disabled />
              </div>
              <span><FiLock aria-hidden="true" />고정</span>
            </div>

            {loginMode === 'member' ? (
              <>
                <div className="lms-login-field">
                  <label htmlFor="userId">아이디</label>
                  <input type="text" id="userId" name="username" ref={userIdRef} value={userId} onChange={(event) => setUserId(event.target.value)} placeholder="아이디 입력" autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false} required />
                </div>
                <div className="lms-login-field">
                  <label htmlFor="password">비밀번호</label>
                  <input type="password" id="password" name="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="비밀번호 입력" autoComplete="current-password" required />
                </div>
                <div className="lms-login-options">
                  <label><input type="checkbox" checked={isIdChecked} onChange={handleIdClick} /><span>아이디 저장</span></label>
                  <label><input type="checkbox" checked={isAutoLoginChecked} onChange={handleAutoLoginClick} /><span>자동 로그인</span></label>
                </div>
              </>
            ) : (
              <>
                <div className="lms-login-field">
                  <label htmlFor="parentPhone">학부모 휴대폰</label>
                  <input
                    type="tel"
                    id="parentPhone"
                    name="tel"
                    value={parentPhone}
                    onChange={(event) => {
                      setParentPhone(event.target.value);
                      setParentCodeSent(false);
                      setParentCertCode('');
                    }}
                    placeholder="휴대폰 번호 입력"
                    autoComplete="tel"
                    inputMode="tel"
                    spellCheck={false}
                    required
                  />
                </div>
                {!parentSavedSessionAvailable ? (
                  <>
                    <div className="lms-login-field">
                      <label htmlFor="parentCertCode">인증번호</label>
                      <div className="lms-login-otp">
                        <input type="text" id="parentCertCode" value={parentCertCode} onChange={(event) => setParentCertCode(event.target.value.replace(/[^0-9]/g, ''))} placeholder="6자리 입력" inputMode="numeric" autoComplete="one-time-code" maxLength={6} disabled={!parentCodeSent} spellCheck={false} />
                        <button type="button" onClick={fncParentSendCode} disabled={sendingParentCode || verifyingParentLogin}>{sendingParentCode ? '전송 중...' : parentCodeSent ? '다시 받기' : '인증번호 받기'}</button>
                      </div>
                    </div>
                    <p className="lms-login-help" role="status">{parentCodeSent ? '휴대폰으로 받은 인증번호를 입력해 주세요.' : '학원에 등록된 학부모 휴대폰 번호로 인증해 주세요.'}</p>
                  </>
                ) : <p className="lms-login-help" role="status">이 기기에 저장된 인증 정보로 바로 로그인할 수 있습니다.</p>}
              </>
            )}

            <button className="lms-login-submit" type="submit" disabled={verifyingParentLogin}>
              {verifyingParentLogin ? '로그인 중...' : loginMode === 'parent' ? '학부모 로그인' : '로그인'}
              {!verifyingParentLogin && <FiArrowRight aria-hidden="true" />}
            </button>
          </form>

          <nav className="lms-login-recovery" aria-label="계정 찾기">
            <Link to="/findId">아이디 찾기</Link>
            <Link to="/findPw">비밀번호 찾기</Link>
          </nav>
          <p className="lms-login-signup">처음 이용하시나요? <Link to="/signup">회원가입</Link></p>
        </section>
        <footer className="lms-login-footer">
          <nav aria-label="로그인 도움말">
            <Link to="/">홈으로</Link>
            <Link to="/deleteId">계정 삭제</Link>
            {appVersion && <button type="button" onClick={handleUpdate}>업데이트</button>}
          </nav>
          {appVersion && <p>버전 {appVersion}{currentVersion ? ' · ' + currentVersion : ''}</p>}
        </footer>
      </div>
    </main>
  );
}

export default BasicLogin;









